<div
    *ngIf="agentInfo"
    class="hover:shadow-xl transition-all rounded-lg p-4 flex-col flex-start-center border border-line cursor-pointer h-full relative"
    (click)="goWatchlist()"
>
    <div *ngIf="agentInfo.is_subscribed" class="subscribed-bg z-0"></div>

    <div class="relative max-md:flex-start-center w-full gap-x-2 flex-1">
        <div class="relative h-10 w-10 min-w-10 mx-auto">
            <nz-avatar [nzSrc]="agentInfo.logo_url" class="!w-full !h-full !leading-10 !bg-secondaryCard"></nz-avatar>

            <img *ngIf="agentInfo.is_subscribed" class="absolute bottom-0 right-0 w-4 h-4" src="/assets/imgs/icon/green-checked.png" alt="" />
        </div>

        <div class="md:mt-2 md:text-center flex-1">
            <div class="text-sm md:text-base font-semibold truncate">{{agentInfo.name || 'Unnamed'}}</div>

            <div class="hidden md:block mt-1 text-sub-text text-xs truncate">{{agentInfo.introduction}}</div>

            <div class="flex-start-center md:flex-center-center gap-x-2.5 mt-1">
                <div
                    class="h-6 bg-secondaryCard px-2 rounded-md leading-6 text-2xs flex-start-center md:hidden"
                    (click)="$event.stopPropagation()"
                    [nz-tooltip]="agentInfo.introduction"
                    nzTooltipPlacement="bottom"
                    nzTooltipTrigger="click"
                >
                    <span>Info</span>
                    <span nz-icon nzType="right" class="text-2xs"></span>
                </div>

                <div class="h-6 bg-secondaryCard px-2 rounded-md leading-6 text-2xs truncate max-md:max-w-[86px]">
                    By {{commonService.getAddrName(agentInfo) | address}}
                </div>

                <a
                    *ngIf="agentInfo.twitter_username"
                    class="h-6 bg-secondaryCard px-2 rounded-md w-6 flex-center-center"
                    [href]="'https://x.com/' + agentInfo.twitter_username"
                    target="_blank"
                >
                    <span nz-icon nzType="antd:x" class="text-sm"></span>
                </a>
            </div>
        </div>

        <div *ngIf="!agentInfo.is_subscribed" class="md:hidden" (click)="$event.stopPropagation()">
            <button nz-button class="!text-2xs !h-8">Subscribe</button>
        </div>
        <div *ngIf="agentInfo.is_subscribed" class="md:hidden" (click)="$event.stopPropagation();unsubscribeModalVisible = true">
            <button nz-button class="!text-2xs !h-8">Unsubscribe</button>
        </div>
    </div>

    <div class="mt-4 grid grid-cols-3 md:grid-cols-2 gap-2 text-[9px] md:text-xs font-normal w-full">
        <div>
            <div class="text-sub-text">Wallet Count</div>
            <div class="font-medium leading-[22px] flex-start-center gap-x-1">
                <img src="/assets/imgs/chains/eth-blue.png" class="w-3 h-3 md:w-4 md:h-4" alt="" />
                <span>{{agentInfo.address_count || 0}}</span>

                <img src="/assets/imgs/chains/solana.png" class="w-3 h-3 md:w-4 md:h-4 ml-3" alt="" />
                <span>{{agentInfo.address_count_sol || 0}}</span>
            </div>
        </div>

        <div>
            <div class="text-sub-text">Daily Alerts</div>
            <div class="font-medium leading-[22px]">{{(agentInfo.stats?.alert_1d || 0) | number:'1.0-2'}}</div>
        </div>

        <div>
            <div class="text-sub-text">Daily Hunted MEMEs</div>
            <div class="font-medium leading-[22px]">{{(agentInfo.stats?.meme_hunted_1d || 0) | number:'1.0-2'}}</div>
            <div *ngIf="agentInfo.stats_base || agentInfo.stats_bsc || agentInfo.stats_sol" class="font-normal text-[11px] leading-[1.1] text-[#999]">
                <div class="flex-start-center gap-x-0.5">
                    <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                    <div>{{agentInfo?.stats_sol?.meme_hunted_1d ?? '-'}}</div>
                </div>
                <div class="flex-start-center gap-x-0.5 mt-1">
                    <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                    <div>{{agentInfo?.stats_base?.meme_hunted_1d ?? '-'}}</div>
                </div>
                <div class="mt-1 flex-start-center gap-x-0.5">
                    <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                    <div>{{agentInfo?.stats_bsc?.meme_hunted_1d ?? '-'}}</div>
                </div>
            </div>
        </div>

        <div>
            <div class="text-sub-text">7D Pnl</div>
            <div
                class="font-medium leading-[22px]"
                [ngClass]="{
                    'text-success': agentInfo.stats?.pnl_7d > 0,
                    'text-error': agentInfo.stats?.pnl_7d < 0
                }"
            >
                <div class="value" [ngClass]="{'text-success': agentInfo.stats?.pnl_7d > 0, 'text-error': agentInfo.stats?.pnl_7d < 0}">
                    {{formatNumberWithPrefix(agentInfo.stats?.pnl_7d || 0,'$')}}
                    <span>({{agentInfo.stats?.pnl_7d > 0 ? '+' : ''}}{{(agentInfo.stats?.pnl_7d / agentInfo.stats?.buy_usd_7d || 0)|percent:'1.0-2'}})</span>
                </div>

                <div class="font-normal text-[11px] leading-[1.1] text-[#999]" *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc">
                    <div class="flex-start-center gap-x-0.5">
                        <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                        <span *ngIf="agentInfo?.stats_sol?.pnl_7d">
                            {{formatTinyNumber(agentInfo?.stats_sol?.pnl_7d || 0)}}
                            <span>
                                ({{agentInfo?.stats_sol?.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_sol?.pnl_7d / agentInfo?.stats_sol?.buy_usd_7d ||
                                0)|percent:'1.0-2'}})
                            </span>
                        </span>

                        <span *ngIf="!agentInfo?.stats_sol?.pnl_7d">-</span>
                    </div>

                    <div class="flex-start-center gap-x-0.5 mt-1">
                        <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                        <span *ngIf="agentInfo?.stats_base?.pnl_7d">
                            {{formatTinyNumber(agentInfo?.stats_base.pnl_7d || 0)}}
                            <span>
                                ({{agentInfo?.stats_base.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_base.pnl_7d / agentInfo?.stats_base.buy_usd_7d ||
                                0)|percent:'1.0-2'}})
                            </span>
                        </span>

                        <span *ngIf="!agentInfo?.stats_base?.pnl_7d">-</span>
                    </div>

                    <div class="flex-start-center gap-x-0.5 mt-1">
                        <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                        <span *ngIf="agentInfo?.stats_bsc?.pnl_7d">
                            {{formatTinyNumber(agentInfo?.stats_bsc.pnl_7d || 0)}}
                            <span>
                                ({{agentInfo?.stats_bsc.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_bsc.pnl_7d / agentInfo?.stats_bsc.buy_usd_7d ||
                                0)|percent:'1.0-2'}})
                            </span>
                        </span>

                        <span *ngIf="!agentInfo?.stats_bsc?.pnl_7d">-</span>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="text-sub-text">Subscribers</div>
            <div class="font-medium leading-[22px]">{{(agentInfo.subscriber_count || 0) | number:'1.0-2'}}</div>
        </div>

        <div>
            <div class="text-sub-text">Subscription Earning</div>

            <div class="flex-start-center leading-[22px]">
                <img src="/assets/imgs/icon/sun-v2.png" alt="" class="w-3 h-3 p-0.5 rounded-full bg-black mr-1" />
                <span class="text-sm font-semibold">{{(agentInfo.total_points_earned || 0) | kmb2:2}}</span>
            </div>
        </div>
    </div>

    <div class="h-10 mt-4 w-full hidden md:block">
        <button
            *ngIf="!agentInfo.is_subscribed && !isMyWatchlist"
            nz-button
            [nzType]="hovering ? 'primary' : 'default'"
            class="w-full"
            (click)="$event.stopPropagation()"
            [nzLoading]="submitting"
            nz-dropdown
            [nzDropdownMenu]="subscribeMenu"
            [nzTrigger]="'click'"
        >
            <span class="text-xs" [ngClass]="{'colorful-text font-semibold': hovering, 'text-black font-normal': !hovering}"> Subscribe (100 Points) </span>
            <span *ngIf="hovering" nz-icon nzType="antd:colorful-caret-down" class="text-sm"></span>
            <span *ngIf="!hovering" nz-icon nzType="antd:caret-down" class="text-sm"></span>
        </button>

        <button
            *ngIf="agentInfo.is_subscribed && !isMyWatchlist && hovering"
            nz-button
            [nzType]="'default'"
            class="w-full"
            (click)="$event.stopPropagation();unsubscribeModalVisible = true"
            [nzLoading]="submitting"
        >
            <span class="text-xs">Unsubscribe</span>
        </button>
    </div>
</div>

<nz-dropdown-menu #subscribeMenu="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item (click)="subscribe()">
            <div class="flex-start-center gap-x-2 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/icon/sun-v2.png" class="w-full h-full" alt="" />
                </div>

                <span>100 Points</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black">
                    <img src="/assets/imgs/hemera-black.png" class="w-full h-full" alt="" />
                </div>
                <span>$DAY</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/usdt.png" class="w-full h-full" alt="" />
                </div>

                <span>USDT</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/usdc.png" class="w-full h-full" alt="" />
                </div>

                <span>USDC</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>
    </ul>
</nz-dropdown-menu>

<nz-modal
    nzTitle="Confirm to unsubscribe from {{agentInfo?.name || 'Unnamed'}}?"
    [(nzVisible)]="unsubscribeModalVisible"
    (nzOnCancel)="unsubscribeModalVisible = false"
    nzCentered
    [nzClosable]="false"
>
    <ng-container *nzModalContent>
        <div class="text-center text-[#999]">Once completed, 1 subscription slot will be freed, and used points won't be refunded.</div>
    </ng-container>

    <ng-container *nzModalFooter>
        <button nz-button nzType="default" (click)="unsubscribeModalVisible = false">Cancel</button>
        <button nz-button nzType="primary" (click)="unsubscribe()" [nzLoading]="submitting">Confirm</button>
    </ng-container>
</nz-modal>
